<ion-header class="ion-no-border">
  <ion-toolbar color="primary" class="enhanced-toolbar">
    <ion-title class="enhanced-title">
      <ion-icon name="create-outline" slot="start"></ion-icon>
      Modifica Gruppo Multipaziente
    </ion-title>

    <ion-buttons slot="end">
      <ion-spinner color="secondary" *ngIf="(loadingPatList$ | async)"></ion-spinner>
      <ion-button fill="clear" (click)="closeModal()" class="close-button">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="enhanced-content">
  <form [formGroup]="form" class="enhanced-form">

    <!-- Sezione informazioni gruppo -->
    <div class="form-section">
      <div class="section-header">
        <ion-icon name="information-circle-outline" class="section-icon"></ion-icon>
        <h3>Informazioni Gruppo</h3>
      </div>
      <div class="group-info-card">
        <div class="group-name-display">
          <ion-icon name="people" class="group-icon"></ion-icon>
          <div>
            <h2>{{name}}</h2>
            <p>Gruppo multipaziente in modifica</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Sezione pazienti attuali -->
    <div class="form-section">
      <div class="section-header">
        <ion-icon name="people" class="section-icon"></ion-icon>
        <h3>Pazienti nel Gruppo</h3>
        <ion-badge color="primary" class="count-badge">{{multiPatientList.length}}</ion-badge>
      </div>

      <div class="current-patients">
        <div class="patient-card" *ngFor="let patient of multiPatientList;">
          <div class="patient-details">
            <ion-avatar class="patient-avatar-small">
              <ion-icon name="person"></ion-icon>
            </ion-avatar>
            <div class="patient-text">
              <h4>{{ patient.name }} {{ patient.surname }}</h4>
              <p>Membro del gruppo</p>
            </div>
          </div>

          <ion-button fill="clear" color="danger" size="small" (click)="elimina(patient)" class="remove-button">
            <ion-icon name="close-circle" slot="icon-only"></ion-icon>
          </ion-button>

          <div *ngIf="multiPatientList.length <= 2 && mode === 'televisita'" class="minimum-notice">
            <ion-icon name="shield-checkmark" color="warning"></ion-icon>
            <span>Minimo richiesto</span>
          </div>
        </div>

        <div class="min-patients-info" *ngIf="multiPatientList.length <= 2">
          <ion-icon name="information-circle" color="warning"></ion-icon>
          <span>È necessario inserire almeno {{mode === 'televisita' ? 2 : 1}} partecipante e il nome del gruppo</span>
        </div>
      </div>
    </div>

    <!-- Sezione aggiungi pazienti -->
    <div class="form-section">
      <div class="section-header">
        <ion-icon name="person-add-outline" class="section-icon"></ion-icon>
        <h3>Aggiungi Nuovi Pazienti</h3>
      </div>

      <div class="search-container">
        <ion-item class="enhanced-item search-item" lines="none">
          <ion-label position="stacked" class="enhanced-label">Cerca Pazienti da Aggiungere</ion-label>
          <ion-input type="text" formControlName="patientId" required
                     placeholder="Inizia a digitare cognome o codice fiscale..." [c3Autocomplete]="autocomplete"
                     [displayWith]="patientDisplayFn" (keyup)="searchPatients()" class="enhanced-input">
          </ion-input>
          <ion-spinner slot="end" color="primary" *ngIf="loadingPatList$ | async">
          </ion-spinner>
        </ion-item>

        <div class="search-hint">
          <ion-icon name="bulb-outline"></ion-icon>
          <span>Digita almeno 3 caratteri per iniziare la ricerca</span>
        </div>

        <c3-autocomplete #autocomplete="c3Autocomplete" class="enhanced-autocomplete">
          <ng-template c3AutocompleteContent>
            <ion-list class="autocomplete-list">
              <ion-list-header *ngIf="filteredPatientList.size === 0" class="no-results">
                <ion-icon name="search-outline"></ion-icon>
                <ion-label>Nessun paziente trovato</ion-label>
              </ion-list-header>

              <c3-option *ngFor="let entry of filteredPatientList | keyvalue" [value]="entry.key">
                <ion-item button (click)="selection(entry)" class="patient-option">
                  <ion-avatar slot="start" class="patient-avatar">
                    <ion-icon name="person"></ion-icon>
                  </ion-avatar>

                  <ion-label class="patient-info">
                    <h3>{{ entry.value?.personalData?.name }} {{ entry.value?.personalData?.surname }}</h3>
                    <p class="fiscal-code">{{ entry.value?.personalData?.fiscalCode }}</p>
                  </ion-label>

                  <ion-icon name="add-circle-outline" slot="end" color="success"></ion-icon>
                </ion-item>
              </c3-option>
            </ion-list>
          </ng-template>
        </c3-autocomplete>
      </div>
    </div>

  </form>
</ion-content>

<ion-footer class="enhanced-footer">
  <div class="footer-actions">
    <ion-button fill="solid" color="primary" [disabled]="creationValue" (click)="updateGruppo()" class="save-button">
      <ion-icon name="save-outline" slot="start"></ion-icon>
      Salva Modifiche
    </ion-button>
  </div>
</ion-footer>